import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { DestinatarioPostModel } from 'model/api/gestao/destinatarios/destinatario-post-model';

export function usePutDestinatario() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putDestinatario = useCallback(
        (destinatario: DestinatarioPostModel) =>
            invocarApi({
                url: `/v1/Propaganda/${destinatario.propagandaId}/Destinatarios/${destinatario.id}`,
                method: 'PUT',
                data: destinatario,
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                enviarTokenUsuario: true,
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putDestinatario,
    };
}
